/**
 * Web auth uses HttpOnly cookies. JWTs must never be read from localStorage.
 * These helpers only purge leftover keys from pre-cookie installs.
 */
const LEGACY_TOKEN_KEYS = ['id_token', 'refresh_token'];

const CLIENT_SESSION_KEYS = [
  ...LEGACY_TOKEN_KEYS,
  'userDetail',
  'rbac_screens',
  'rbac_permissions',
];

export function purgeLegacyAuthTokens() {
  LEGACY_TOKEN_KEYS.forEach((key) => {
    try {
      localStorage.removeItem(key);
    } catch (_) {
      // ignore storage errors (private mode, etc.)
    }
  });
}

export function clearClientSession() {
  CLIENT_SESSION_KEYS.forEach((key) => {
    try {
      localStorage.removeItem(key);
    } catch (_) {
      // ignore
    }
  });
}
